import AnnotationSequenceItem from './AnnotationSequenceItem';

export default AnnotationSequenceItem;
